(function () {
    'use strict';

    angular
        .module('app.saveAsCustomReport', [])
        .controller('saveAsCustomReportCtrl', ['$scope', '$rootScope', '$modal', '$modalInstance', 'saveAsCustomReportService',
            function ($scope, $rootScope, $modal, $modalInstance, saveAsCustomReportService) {

                $scope.confirmSaveAs = function() {
                    var params = {
                        id: $scope.reportId,
                        company_id: $scope.selectedAdvertiser,
                        report_name: $scope.customReportName,
                        sections: $scope.selectedSection
                    }

                    saveAsCustomReportService.saveAsCustomReport(params, true)
                        .then(function(response) {
                            $scope.saveAsCustomReportModalInstance.close();
                            $scope.detailCustomReportModalInstance.close();
                            $scope.sendHttpRequest();
                        }, function(response) {
                            console.log(response);
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        })
                }

                $scope.closeModal = function() {
                    $modalInstance.close();
                }
            }
        ]);
})();